var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"selectcard-hover items-center"},[_c('p',{staticClass:"font-semibold text-sm mb-2"},[_vm._v("Category")]),_c('b-input',{attrs:{"placeholder":"Enter Category Order..."}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }